export const BOPIS_MSG_GET_SUCCESS = 'BOPIS_MSG_GET_SUCCESS';
export const BOPIS_MSG_GET_FAILURE = 'BOPIS_MSG_GET_FAILURE';
export const BOPIS_MSG_GET_REQUEST = 'BOPIS_MSG_GET_REQUEST';
export const RESET_BOPIS_MESSAGE = 'RESET_BOPIS_MESSAGE';
